import { render, staticRenderFns } from "./log_info.vue?vue&type=template&id=50efc96e&scoped=true"
import script from "./log_info.vue?vue&type=script&lang=js"
export * from "./log_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50efc96e",
  null
  
)

export default component.exports